var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionYayNoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0969 11.3556C23.0969 17.6271 18.0128 22.7111 11.7413 22.7111C5.4698 22.7111 0.385742 17.6271 0.385742 11.3556C0.385742 5.08406 5.4698 0 11.7413 0C18.0128 0 23.0969 5.08406 23.0969 11.3556Z",
    fill: "#FBF2C3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.35895,
    cy: 11.0513,
    r: 3.25153,
    fill: "url(#paint0_radial_1209_25242)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.35895,
    cy: 11.0513,
    r: 3.25153,
    fill: "url(#paint1_radial_1209_25242)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5734 8.46247C22.5734 10.2582 21.1176 11.714 19.3218 11.714C17.5261 11.714 16.0703 10.2582 16.0703 8.46247C16.0703 6.6667 17.5261 5.21094 19.3218 5.21094C21.1176 5.21094 22.5734 6.6667 22.5734 8.46247Z",
    fill: "url(#paint2_radial_1209_25242)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5734 8.46247C22.5734 10.2582 21.1176 11.714 19.3218 11.714C17.5261 11.714 16.0703 10.2582 16.0703 8.46247C16.0703 6.6667 17.5261 5.21094 19.3218 5.21094C21.1176 5.21094 22.5734 6.6667 22.5734 8.46247Z",
    fill: "url(#paint3_radial_1209_25242)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54884 7.93746C8.38385 7.3217 7.75092 6.95628 7.13516 7.12127C6.5194 7.28626 6.15398 7.91919 6.31897 8.53495L5.86821 8.65573C5.63651 7.79102 6.14967 6.9022 7.01438 6.6705C7.87909 6.43881 8.76791 6.95196 8.99961 7.81668L8.54884 7.93746Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7672 6.61867C15.6456 5.9929 15.0397 5.58422 14.4139 5.70586C13.7881 5.82749 13.3795 6.43339 13.5011 7.05916L13.043 7.1482C12.8722 6.26943 13.4461 5.41858 14.3249 5.24776C15.2036 5.07695 16.0545 5.65086 16.2253 6.52963L15.7672 6.61867Z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66599 12.8796C8.94285 12.9578 10.6627 12.8036 12.519 12.3928C14.3754 11.982 15.9997 11.3963 17.1244 10.7867C17.6881 10.4811 18.1142 10.176 18.3819 9.89311C18.6562 9.60321 18.7227 9.38319 18.6889 9.23057L19.1446 9.12975C19.2294 9.51309 19.0296 9.88759 18.7208 10.2139C18.4054 10.5472 17.9316 10.8799 17.3467 11.1969C16.1741 11.8325 14.5062 12.431 12.6198 12.8485C10.7335 13.2659 8.96876 13.4269 7.63746 13.3454C6.97346 13.3047 6.40349 13.203 5.97689 13.0339C5.55931 12.8683 5.22016 12.6131 5.13534 12.2297L5.59098 12.1289C5.62475 12.2815 5.77785 12.4529 6.14888 12.6C6.5109 12.7436 7.02592 12.8404 7.66599 12.8796Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66599 12.8796C8.94285 12.9578 10.6627 12.8036 12.519 12.3928C14.3754 11.982 15.9997 11.3963 17.1244 10.7867C17.6881 10.4811 18.1142 10.176 18.3819 9.89311C18.6562 9.60321 18.7227 9.38319 18.6889 9.23057L19.1446 9.12975C19.2294 9.51309 19.0296 9.88759 18.7208 10.2139C18.4054 10.5472 17.9316 10.8799 17.3467 11.1969C16.1741 11.8325 14.5062 12.431 12.6198 12.8485C10.7335 13.2659 8.96876 13.4269 7.63746 13.3454C6.97346 13.3047 6.40349 13.203 5.97689 13.0339C5.55931 12.8683 5.22016 12.6131 5.13534 12.2297L5.59098 12.1289C5.62475 12.2815 5.77785 12.4529 6.14888 12.6C6.5109 12.7436 7.02592 12.8404 7.66599 12.8796Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1209_25242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.35895 11.0513) rotate(90) scale(3.25153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1209_25242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.35895 11.0513) rotate(90) scale(3.25153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1209_25242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6715 8.46247) rotate(90) scale(3.25153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1209_25242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6715 8.46247) rotate(90) scale(3.25153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionYayNoBg);
export default __webpack_public_path__ + "static/media/reaction_yay_no-bg.497899af88f106f3d8294e4730d9c5b0.svg";
export { ForwardRef as ReactComponent };